export default {
  apiTrafficManager: "https://charuzit-4-1.loadbalancer.dicta.org.il",
}
